/**
 * Provides JS functionality for tracking alert display.
 */
export class TextCards extends DrupalBehavior {
  onContent(context) {
    $('.text-card .link-list--title', context).on('click', function (e) {
      e.preventDefault();
      let $links = $(this).parent().parent().find('.link-list--items');
      $links.toggleClass('open');
    });
    $('.text-card .link-list--items .close', context).on('click', function (e) {
      e.preventDefault();
      let $links = $(this).parent();
      $links.toggleClass('open');
    });

    const textCard = context.querySelector('.text-card');

    if (textCard) {
      const cards = context.querySelectorAll('.text-card');

      cards.forEach((card) => {
        const singleLink = card.querySelector('.paragraph--type--single-link');
        if (singleLink) {
          const link = singleLink.querySelector('a');

          if (link.getAttribute('href') === '/appointment') {
            const links = card.querySelectorAll('a');
            links.forEach((element) => {
              element.setAttribute('data-dialog-type', 'modal');
              element.classList.add('use-ajax');
            });
          }
        }
      });
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'text_cards', TextCards);
